import React from 'react';
import PropTypes from 'prop-types';
import Card from '@mui/material/Card';
import { useTheme } from '@mui/material/styles';
import { glassPanel } from '../../themes/gradients';

/**
 * Card com efeito de vidro (glassmorphism) - fundo translúcido + blur,
 * fica "flutuando" sobre o gradiente de fundo do layout (ver
 * MainLayout), com o vidro ficando mais nítido (menos blur, borda glow)
 * ao passar o mouse - é o "efeito de vidro transparente no hover"
 * pedido. `accent` (chave de themes/gradients.js) tinge a borda/sombra
 * do hover; sem isso fica neutro. Passe a cor sólida (ex: `gradients.blue.main`),
 * não o gradiente cheio.
 */
const GlassCard = React.forwardRef(({ children, accent, hoverable = true, sx = {}, ...rest }, ref) => {
    const theme = useTheme();
    const accentColor = accent;
    const isDark = theme.palette.mode === 'dark';

    return (
        <Card
            ref={ref}
            elevation={0}
            sx={{
                ...glassPanel(theme),
                borderRadius: '20px',
                position: 'relative',
                overflow: 'hidden',
                boxShadow: isDark ? '0 8px 32px rgba(0,0,0,0.35)' : '0 8px 32px rgba(15,23,42,0.08)',
                transition: 'transform 0.25s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.25s ease, border-color 0.25s ease',
                ...(hoverable && {
                    '&:hover': {
                        transform: 'translateY(-4px)',
                        boxShadow: accentColor
                            ? `0 16px 40px ${accentColor}26, 0 4px 14px ${accentColor}1f`
                            : isDark
                              ? '0 16px 40px rgba(0,0,0,0.45)'
                              : '0 16px 40px rgba(15,23,42,0.14)',
                        borderColor: accentColor ? `${accentColor}55` : undefined
                    }
                }),
                ...sx
            }}
            {...rest}
        >
            {children}
        </Card>
    );
});

GlassCard.propTypes = {
    children: PropTypes.node,
    accent: PropTypes.string,
    hoverable: PropTypes.bool,
    sx: PropTypes.object
};

export default GlassCard;
